const getQueryParams = () => {
    var r = {},
        n = function(r) {
            return decodeURIComponent(r.replace(/\+/g, " "));
        },
        t = location.search.substring(1).split("&");
    for (var e in t) {
        var o = t[e].toString().split("=");
        o.length > 1 && (r[n(o[0])] = n(o[1]));
    }
    return r;
};

module.exports = getQueryParams;
